import {
  HELP_TOGGLE,
  SET_PAGE_TITLE,
  SORT_ASSETS,
  SWITCH_ASSETS_VIEW,
  TOGGLE_FILTER_BAR,
  TOGGLE_UPLOADS_TRAY,TOGGLE_UPLOAD_TYPE,
  CHOOSE_UPLOAD, START_SINGLE_UPLOAD,UPLOAD_BOX_VISIBLE,
  START_UPLOAD,REMOVE_START_STATE,SHOW_UPLOADS_TRAY,
  RESUMABLE_TYPE, NORMAL_TYPE,

  SET_AQI_CITIES, SET_AQI_STATIONS,SET_AIRVEDA_STATIONS,
  SET_WEATHER_STATIONS,

  TRANSCODE_VIDEO, SHOW_GROUP_FEED, SET_QUIZ_STATIONS,
} from 'signoxe/constants/actionTypes';

export const setPageTitle = (title) => ({type: SET_PAGE_TITLE, title});

export const toggleHelp = () => ({type: HELP_TOGGLE});

export const toggleFilterBar = () => ({type: TOGGLE_FILTER_BAR});

export const toggleUploadsTray = () => ({type: TOGGLE_UPLOADS_TRAY});
export const showUploadsTray = () => ({type: SHOW_UPLOADS_TRAY})

export const toggleUploadType = () => ({type: TOGGLE_UPLOAD_TYPE})
export const switchResumable = () => ({type:RESUMABLE_TYPE})
export const switchNormal = () => ({type:NORMAL_TYPE})

export const selectUploadFiles = (data) => ({type: CHOOSE_UPLOAD, payload: data})
export const startUploadFile = (data) => ({type: START_SINGLE_UPLOAD, payload: data})
export const toggleUploadDispatchBox = () => ({type: UPLOAD_BOX_VISIBLE})

export const startUpload = (data) => ({type: START_UPLOAD, payload: data})
export const toggleStartState = (data) => ({type: REMOVE_START_STATE})

export const switchAssetView = (view) => ({type: SWITCH_ASSETS_VIEW, view});

export const changeAssetsSort = (sortBy, reversed) => ({
  type: SORT_ASSETS,
  sortBy,
  reversed,
});

export const setAQICities = cities => ({type: SET_AQI_CITIES, cities});
export const setAQIStations = (city, stations) => ({type: SET_AQI_STATIONS, city, stations});
export const setAirvedaStations = (stations) => ({type: SET_AIRVEDA_STATIONS, stations});
export const setWeatherStations = (stations) => ({ type: SET_AIRVEDA_STATIONS, stations });

export const setQuizStations = (stations) => ({ type: SET_QUIZ_STATIONS, stations });

export const transcodeVideo = id => ({type: TRANSCODE_VIDEO, id});

export const toggleDeviceId = id => ({ type: SHOW_GROUP_FEED, id });






// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/ui.js